/**
 * Created by shubham on 20/11/18.
 */

/**
 * A model for an individual corporate employee
 */
export class BusinessUnitListDashboard {
    countryId: string;
    countryName: string;
    businessUnitId: string;
    businessUnitName: boolean;
    emailVerified: string;
    customerNumber: string;
    selectedApplicationNames: string;
    status: string;
    active: boolean;

    constructor(countryId:string, countryName:string, businessUnitId:string, businessUnitName:boolean, emailVerified:string,
                customerNumber:string, selectedApplicationNames: string, status:string, active: boolean){
        this.countryId = countryId;
        this.countryName = countryName;
        this.businessUnitId = businessUnitId;
        this.businessUnitName = businessUnitName;
        this.emailVerified = emailVerified;
        this.customerNumber = customerNumber;
        this.selectedApplicationNames = selectedApplicationNames;
        this.status = status;
        this.active = active;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user-operations/request-business-unit/businessUnitList-datatable/businessUnitList-dashboard.ts